const headerScript = () => {
    document.querySelector("#lng").addEventListener('change', function (e) {
        this.closest('form').submit()
    })

    var business = document.querySelector('.header-container-business');
    if (business !== null) {
        return;
    }

    document.querySelector("#header-container .hamburger").addEventListener('click', function(e) {
        e.preventDefault();
        this.style.display = "none";
        document.getElementsByClassName("close")[0].style.display = "block";
        document.getElementsByClassName("dropdown_items_mobile_box")[0].style.display = "block";

        document.querySelector(".close").addEventListener('click', function() {
            this.style.display = "none";
            document.getElementsByClassName("dropdown_items_mobile_box")[0].style.display = "none";
            document.getElementsByClassName("hamburger")[0].style.display = "";
        });
    });

    $(document).ready(function () {
        $('.accordion_title_wrapper').on('click', function (e) {
            $(this).parent().toggleClass('show');
        });

        $('.link-container').on('click', function (e) {
            const dropdown = $(this).find('.link-container_dropdown');
            const title = $(this).find('.link-container_title');
            const arrow = $(this).find('.link-container_arrow');

            if (dropdown.hasClass('hidden')) {
                dropdown.removeClass('hidden');
                title.addClass('opened');
                arrow.addClass('rotate');
            } else {
                dropdown.addClass('hidden');
                title.removeClass('opened');
                arrow.removeClass('rotate');
            }
        });

        $('.link-container_mobile').on('click', function (e) {
            const dropdown = $(this).find('.link-container_dropdown_mobile');
            const arrow = $(this).find('.link-container_arrow_mobile');

            if (dropdown.hasClass('hidden')) {
                dropdown.removeClass('hidden');
                arrow.addClass('rotate');
            } else {
                dropdown.addClass('hidden');
                arrow.removeClass('rotate');
            }
        });

        $(document).on({
            mouseenter: function () {
                const container = $(this).find('.dropdown_list_items_desktop');
                container.css('margin-left', $(this).position().left+'px');
            }
        }, ".items_wrapper_desktop");
    })
}

headerScript();
